module.exports = __webpack_public_path__ + "static/media/RGB-180612-10061.be95cbea.jpg";